(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["moonstruck-shipping-runtime"] && !Shopify.designMode) return;
  try {
    (() => {
  const configElement = document.getElementById('ms-shipping-config');
  if (!configElement || window.moonstruckShippingLoaded) return;
  window.moonstruckShippingLoaded = true;
  const config = JSON.parse(configElement.textContent);
  const root = config.root.endsWith('/') ? config.root : config.root + '/';
  const form = document.getElementById('ms-shipping-localization');
  const preferenceKey = 'moonstruck_shipping_country';
  const checkedKey = 'moonstruck_country_localization_checked';

  function storageGet(storage, key) {
    try { return window[storage].getItem(key); } catch (_) { return null; }
  }
  function storageSet(storage, key, value) {
    try { window[storage].setItem(key, value); } catch (_) { return; }
  }
  function rememberCountry(code) {
    if (!config.countries.some(country => country.code === code)) return;
    storageSet('localStorage', preferenceKey, JSON.stringify({ country: code, time: Date.now() }));
  }
  function hasCountryPreference() {
    try {
      const saved = JSON.parse(storageGet('localStorage', preferenceKey));
      return saved && config.countries.some(country => country.code === saved.country) && Date.now() - saved.time < 90 * 86400000;
    } catch (_) { return false; }
  }
  function setCountry(code, manual) {
    if (!form || !config.countries.some(country => country.code === code)) return;
    if (manual) rememberCountry(code);
    storageSet('sessionStorage', checkedKey, '1');
    form.elements.country_code.value = code;
    let returnTo = form.querySelector('[name="return_to"]');
    if (!returnTo) {
      returnTo = document.createElement('input');
      returnTo.type = 'hidden';
      returnTo.name = 'return_to';
      form.append(returnTo);
    }
    returnTo.value = window.location.pathname + window.location.search + window.location.hash;
    HTMLFormElement.prototype.submit.call(form);
  }
  document.addEventListener('change', event => {
    if (event.target.matches('[name="country_code"]')) rememberCountry(event.target.value);
  }, true);
  document.addEventListener('submit', event => {
    const country = event.submitter?.name === 'country_code' ? event.submitter : event.target.querySelector('input[name="country_code"], select[name="country_code"]');
    if (country) rememberCountry(country.value);
  }, true);

  function shippingState(total, currency, country, exchangeRate) {
    if (!config.countries.some(destination => destination.code === country)) return { key: 'unavailable', contact: true };
    if (!Number.isSafeInteger(total) || total < 0) return { key: 'confirm', contact: true };
    if (country === 'US') return { key: 'us_minimum', contact: true };
    const minimumConfig = config.rules.minimum;
    let factor = 1;
    if (currency !== minimumConfig.currency) {
      if (minimumConfig.currency !== config.shopCurrency || !Number.isFinite(exchangeRate) || exchangeRate <= 0) return { key: 'confirm', contact: true };
      factor = exchangeRate;
    }
    const minimum = Math.ceil(minimumConfig.amount * factor);
    const approximate = factor !== 1;
    if (total < minimum) return { key: 'minimum', minimum, remaining: minimum - total, approximate, contact: true };
    return { key: 'minimum_met', minimum, approximate, contact: true };
  }

  class MoonstruckShippingNotice extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.sequence = 0;
      const options = { signal: this.controller.signal };
      this.querySelector('.ms-shipping__apply').addEventListener('click', () => setCountry(this.querySelector('[data-ms-shipping-country]').value, true), options);
      document.addEventListener('cart:change', event => {
        this.sequence += 1;
        if (event.detail?.cart) this.update(event.detail.cart);
      }, options);
      document.addEventListener('cart:refresh', () => this.refresh(), options);
      window.addEventListener('pageshow', event => { if (event.persisted) this.refresh(); }, options);
      this.update({ total_price: Number(this.dataset.total), currency: this.dataset.currency, requires_shipping: true });
    }
    disconnectedCallback() { this.controller?.abort(); }
    async refresh() {
      const sequence = ++this.sequence;
      try {
        const response = await fetch(root + 'cart.js', { credentials: 'same-origin', signal: this.controller.signal });
        if (!response.ok) return;
        const cart = await response.json();
        if (this.isConnected && sequence === this.sequence) this.update(cart);
      } catch (_) { return; }
    }
    update(cart) {
      this.hidden = cart.item_count === 0 || cart.requires_shipping === false;
      if (this.hidden) return;
      const currency = cart.currency || this.dataset.currency;
      const state = shippingState(cart.total_price, currency, this.dataset.country, Number(window.Shopify?.currency?.rate));
      const notice = this.querySelector('.ms-shipping__notice');
      notice.hidden = !state;
      if (!state) return;
      const country = config.countries.find(country => country.code === this.dataset.country)?.name || this.dataset.country;
      const money = cents => new Intl.NumberFormat('en', { style: 'currency', currency, currencyDisplay: 'code' }).format(cents / 100);
      let message = config.messages[state.key];
      for (const [key, value] of Object.entries({ country, minimum: state.minimum == null ? '' : money(state.minimum), remaining: state.remaining == null ? '' : money(state.remaining) })) {
        message = message.replaceAll('[' + key + ']', value);
      }
      if (state.approximate) message = config.messages.approximate + ' ' + message;
      const messageElement = this.querySelector('.ms-shipping__message');
      const remaining = state.remaining == null ? '' : money(state.remaining);
      const amountIndex = remaining ? message.indexOf(remaining) : -1;
      if (amountIndex >= 0) {
        const amount = document.createElement('span');
        amount.className = 'ms-shipping__amount';
        amount.textContent = remaining;
        messageElement.replaceChildren(
          document.createTextNode(message.slice(0, amountIndex)),
          amount,
          document.createTextNode(message.slice(amountIndex + remaining.length))
        );
      } else {
        messageElement.textContent = message;
      }
      this.querySelector('.ms-shipping__contact').hidden = !state.contact;
    }
  }
  if (!customElements.get('moonstruck-shipping-notice')) customElements.define('moonstruck-shipping-notice', MoonstruckShippingNotice);

  async function localizeDestination() {
    const params = new URLSearchParams(window.location.search);
    if (!config.autoUS || config.designMode || window.Shopify?.designMode || params.has('country') || params.has('country_code') || params.has('preview_theme_id') || hasCountryPreference() || storageGet('sessionStorage', checkedKey)) return;
    storageSet('sessionStorage', checkedKey, '1');
    const controller = new AbortController();
    const stop = () => controller.abort();
    document.addEventListener('pointerdown', stop, { once: true, signal: controller.signal });
    document.addEventListener('keydown', stop, { once: true, signal: controller.signal });
    const timer = window.setTimeout(stop, 3000);
    try {
      const query = new URLSearchParams({ 'country[enabled]': 'true', 'country[exclude]': config.country, 'language[enabled]': 'false' });
      const response = await fetch(root + 'browsing_context_suggestions.json?' + query, { credentials: 'same-origin', signal: controller.signal });
      if (!response.ok) return;
      const result = await response.json();
      const detected = result.detected_values?.country?.handle;
      const country = config.countries.find(country => country.code === detected);
      const suggestion = result.suggestions?.find(suggestion => suggestion.parts?.country?.handle === detected);
      if (!country || detected === config.country || (detected === 'US' && country.currency !== 'USD')) return;
      if (!controller.signal.aborted && !hasCountryPreference() && suggestion) setCountry(detected, false);
    } catch (_) { return; }
    finally { window.clearTimeout(timer); controller.abort(); }
  }
  localizeDestination();
})();
  } catch(e) { console.error(e); }
})();

})();
